import React from 'react'
import styles from './FJCover.module.less'

function FJCover() {
  return (
    <div className={styles.cover}/>
  );
}

export default FJCover;